import 'jquery';

export default {
  ready() {
    // Phone button
    jQuery(".btn-call-us").on("click", function(){
      if(jQuery('#div-phones').css('display') != 'flex'){
        jQuery('#div-phones').fadeIn('slow');
        jQuery('#div-phones').css('display','flex');
      }else{
        jQuery('#div-phones').fadeOut('slow');
      }
    });

    // Hours button
    jQuery(".btn-hours").on("click", function(){
      if(jQuery('#div-hours').css('display') != 'flex'){
        jQuery('#div-hours').fadeIn('slow');
        jQuery('#div-hours').css('display','flex');
      }else{
        jQuery('#div-hours').fadeOut('slow');
      }
    });

    const panels = [
      { panel: '#div-phones', trigger: '.btn-call-us' },
      { panel: '#div-hours', trigger: '.btn-hours' },
    ];

    jQuery(document).on("click", function(e){
      panels.forEach(({ panel, trigger }) => {
        if(!jQuery(e.target).closest(panel + ', ' + trigger).length){
          jQuery(panel).filter(':visible').fadeOut('slow');
        }
      });
    });

    jQuery(document).on("keydown", function(e){
      if(e.key === 'Escape'){
        panels.forEach(({ panel }) => jQuery(panel).filter(':visible').fadeOut('slow'));
      }
    });
  }
}